module.exports = __webpack_public_path__ + "img/7.6360ed54.png";